import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MainCard from 'components/MainCard';
import { Autocomplete, Button, CardContent, Modal, Table, TableBody, TableCell, TableContainer, TableRow, TextField } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { modals } from 'components/modals/Modals'; 
import { truncate } from "data/data";
import useModals from 'components/modals/useModal';
import CustomFormEnumSelect from 'components/select/CustomFormEnumSelect';
import { useEnumApi } from 'contexts/EnumApiContext';
import { getCompanyInfoAll } from 'components/axios/joinAxios';
import AddressSearchSwitcher from './AddressSearchSwitcher';

export function CompanyWriteLayer({setIsCompanyLoading, addCompany, setAddCompany, companyTypeParam}) {
  const timezone      = (process.env.REACT_APP_TIMEZONE || 'Asia/Seoul').toLowerCase();
  const { getEnumValueByEnumName } = useEnumApi();
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
    // console.log(addCompany)
  }
  const handleClose = () => setOpen(false);

  // modal 관련
  const { openModal } = useModals();
  const handleAlertClick = (alertMessage) => {
      openModal(modals.alertModal, {
          onClose : () => {
          },
          message: alertMessage,
      });
  };

  const [addressInfo, setAddressInfo] = useState({});
  const [companies, setCompanies] = useState([]);

  useEffect(()=> {
    const fetchCompanies = async () => {
        try {
            const res = await getCompanyInfoAll();
            if (res) setCompanies(res);
        } catch (e) {
            console.error(e);
            setCompanies([]);
        }
    };
    fetchCompanies();
  }, []);

  const { control, register, handleSubmit, reset, setValue, formState : {isDirty, errors } } = useForm({});
    
  // companyType 필드의 값을 실시간으로 감시
//   const selectedCompanyType = watch('companyType');
  // 관리주체('MAN')일 때만 주소를 필수값으로 설정
  const isAddressRequired = companyTypeParam === 'MAN';

  // 현재 선택된 옵션 상태
  const [selectCompany, setSelectCompany] = useState(null);

  // 현재 필드들이 읽기 전용이어야 하는지 판단
  const isReadOnly = !!selectCompany; // 선택된 항목이 있으면 true
// console.log(isReadOnly)
  // 등록
  const onSubmit = async(data) => {
    // setFileLoading(true);
    console.log(data);

    const companyId         = data.info.id;
    const companyType       = data.companyType;
    const businessName      = data.info.name;
    const address           = data.address;
    const businessContact   = data.businessContact;
    const businessRegNo     = data.businessRegNo;

    let dto = {};
    // let formData = new FormData();
    if (companyId) {
        dto = {
            // id : "-1",
            // name : businessName,
            type: companyType,
            info : {
                id : companyId,
                name: businessName
            },
        }

        if (companyTypeParam === 'MAN' && !selectCompany?.address) {
            dto.info.address = address;
            // dto.info.latitude = addressInfo?.lat;
            // dto.info.longitude = addressInfo?.lng;
            // if (appLanguage === 'zh-cn') {
            if (timezone === ('Asia/Shanghai').toLowerCase()) {
                dto.info.chinaRegionCode = addressInfo?.chinaRegionCode ?? null;
            } else {
                dto.info.latitude = addressInfo?.lat ?? null;
                dto.info.longitude = addressInfo?.lng ?? null;
            }
            
        }
    } else {
        dto = {
            // id : "-1",
            // name : businessName,
            type: companyType,
            info : {
                businessRegNo: businessRegNo,
                name: businessName,
                address: address,
                contact: businessContact,
                // latitude : addressInfo?.lat,
                // longitude : addressInfo?.lng
            }
        }

        // if (appLanguage === 'zh-cn') {
        if (timezone === ('Asia/Shanghai').toLowerCase()) {
            dto.info.chinaRegionCode = addressInfo?.chinaRegionCode ?? null;
        } else {
            dto.info.latitude = addressInfo?.lat ?? null;
            dto.info.longitude = addressInfo?.lng ?? null;
        }
    }
console.log(dto);
    // console.log(selectCompany)
    if (selectCompany !== null && selectCompany?.companies?.filter(c=>c.type === companyType).length > 0) {
        handleAlertClick(t('message.common.alert.company.exist'));
        return;
    }
    
    console.log(dto);

    openModal(modals.confirmModal, {
        onSubmit : (value) => {
            setAddCompany(dto)
            setIsCompanyLoading(false)
            handleClose();
        },
        onClose : () => {
            console.log('close');
        },
        message: t('message.common.alert.add.question'),
    });
    // reset();
  };

  return (
      <>
        <Button variant="contained" onClick={handleOpen} style={{minWidth:"unset",color:"#fff", marginRight:"4px"}} color="success">
          <span className="icon_png">{t('message.common.title.company.write')}</span>
        </Button>
  
        <Modal className="pop_box" open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <MainCard style={{maxWidth:"1280px", width:"90%", maxHeight:"75vh"}} title="" modal darkTitle content={false}>
            <CardContent style={{height:"100%"}}>
              <div className='pop_close'>
                <Button color="primary" size="small" onClick={handleClose}>
                  {t('message.common.btn.close')}
                </Button>
              </div>
  
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mro_search">
                    <h6 className="mro_m_left" style={{color:"#fff"}}>
                        * {t('message.common.title.company.write')}<span style={{fontSize:'15px',color:'#c7641e'}}> - {t('message.common.text.company.autoProcessNotice')}</span>
                    </h6>
                </div>
                
                <TableContainer>
                <Table sx={{ minWidth: 1000 }} aria-label="simple table" className="same_width" style={{borderTop:"2px solid #a2a2a2"}} >
                    <TableBody>
                    <TableRow>
                        <TableCell className="th">{t('message.common.subtitle.company.type')} *</TableCell>
                        <TableCell colSpan={3} style={{textAlign: "left"}}>
                            <Controller
                                name="companyType"
                                control={control}
                                render={({ field:{ name }}) => (
                                    <CustomFormEnumSelect
                                        style={{ minWidth: '90%', margin:"8px", pointerEvents: 'none' }}
                                        label={t('message.common.subtitle.company.type')}
                                        register={register}
                                        name={name}
                                        requiredMessage={t('message.common.error.text.company.type.select')}
                                        defaultValue={companyTypeParam || ''}
                                        key={'companyType'}
                                        list={getEnumValueByEnumName('CompanyType')}
                                    />
                                )}
                                rules={{ required: true }}
                            />
                            {errors.companyType && <small role="alert"><br></br>{errors.companyType.message}</small>}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="th">{t('message.common.subtitle.company.name')} *</TableCell>
                        <TableCell colSpan={3} style={{textAlign: "left"}}>
                            <Controller
                                name="info"
                                control={control}
                                defaultValue={null}   // ✅ undefined 방지
                                rules={{ 
                                    // required: t('message.common.error.text.company.name.input'),
                                    validate: (value) => {
                                        // value가 객체일 경우 name, 문자열일 경우 value 자체를 검사
                                        const name = typeof value === 'object' ? value?.name : value;
                                        if (!name || name.trim() === '') {
                                            return t('message.common.error.text.company.name.input');
                                        }
                                        return true;
                                    }
                                }}
                                render={({ field, fieldState }) => (
                                    <Autocomplete
                                    style={{width: "90%"}}
                                    {...field}
                                    value={field.value || null}   // ✅ 항상 null 또는 객체
                                    freeSolo
                                    options={companies}
                                    getOptionLabel={(option) => {
                                        if (!option) return "";
                                        if (typeof option === "string") return option;               // freeSolo 입력값
                                        if (option.inputValue) return option.inputValue;             // 새 값 추가 처리
                                        return `${option.name}${option.address ? `, ${truncate(option?.address ?? "", 10)}` : ""}`;
                                    }}
                                    onChange={(e, value) => {
                                        // console.log(value)
                                        // value가 객체면 기존 업체 선택, 문자열이면 새 업체 등록
                                        if (typeof value === "string") {
                                            field.onChange({ id: null, name: value, address: "" }); // 새 업체명
                                        } else if (value && value.inputValue) {
                                        // createOption 패턴 (입력값 기반 새 객체)
                                            field.onChange({ id: null, name: value.inputValue, address: "" });
                                        } else {
                                            // console.log(3)
                                            field.onChange(value); // 기존 객체
                                            console.log(value)
                                            if (value) {
                                                setSelectCompany(value);
                                                setValue("address", value.address);
                                                setValue("businessContact", value.contact);
                                                setValue("businessRegNo", value.businessRegNo);
                                                setAddressInfo({address_name: value.address, lat:value.latitude ?? null, lng:value.longitude ?? null, chinaRegionCode:value.chinaRegionCode ?? null})
                                            }
                                        }
                                    }}
                                    onInputChange={(e, newInputValue, reason) => {
                                        if (reason === "input") {
                                            field.onChange({id:null, name:newInputValue}); // 타이핑 값도 그대로 저장
                                            // 새 입력한 경우 → 수정 가능하게
                                            setSelectCompany(null);
                                            // field.onChange(newInputValue); // 타이핑 값도 그대로 저장
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                        {...params}
                                        sx={{ m: 1, minWidth: '80%' }} 
                                        label={t('message.common.text.search.company.name')}
                                        error={!!fieldState.error}
                                        />
                                    )}
                                    />
                                )}
                            />
                            {errors.info && <small role="alert"><br></br>{errors.info.message}</small>}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="th">{t('message.common.subtitle.address')} {isAddressRequired && <>*</>}</TableCell>
                        <TableCell colSpan={3} style={{textAlign: "left"}}>
                            {!selectCompany?.id || (companyTypeParam === 'MAN' && !selectCompany?.address) ?
                            // {!selectCompany?.id ?
                            <>
                            <Controller
                                control={control}
                                name="address"
                                rules={{
                                    validate: (value, formValues) => {
                                        // console.log(value)
                                        // console.log(formValues['companyType'] )
                                        if (companyTypeParam === 'MAN' &&
                                            (value === null || value === undefined || value === '')) {
                                            return t('message.common.error.text.address.input');
                                        }
                                        return true;
                                    }
                                    // required: t('message.common.error.text.address.input') 
                                }}
                                render={({ field, fieldState }) => (
                                <AddressSearchSwitcher register={register} setValue={setValue} field={field} fieldState={fieldState} 
                                    errors={errors} setAddressInfo={setAddressInfo} objName={'address'} addressInfo={addressInfo} />
                                )}
                            />
                            {!isAddressRequired &&
                            <Button variant="outlined" color="error" style={{marginTop:"10px"}} 
                                onClick={()=>{
                                    setValue("address", "");
                                    setAddressInfo({address_name: "", lat:"", lng:"", chinaRegionCode:""})
                                }}
                            >X</Button>
                            }
                            {errors.address && <small role="alert"><br></br>{errors.address.message}</small>}
                            </>
                            :
                            <TextField id="address" 
                                {...register("address", {
                                })} 
                                InputProps={{ readOnly: isReadOnly }}
                                sx={{ m: 1, minWidth: '90%' }} 
                            />
                            }
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="th">{t('message.common.subtitle.company.contact')}</TableCell>
                        <TableCell colSpan={3} style={{textAlign: "left"}}>
                            <TextField id="businessContact" 
                                {...register("businessContact", {
                                })} 
                                InputProps={{ readOnly: isReadOnly }}
                                sx={{ m: 1, minWidth: '90%' }}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="th" style={{width:"130px"}}>{t('message.common.subtitle.business.register.no')}</TableCell>
                        <TableCell colSpan={3} style={{textAlign: "left"}}>
                            <TextField id="businessRegNo" 
                                {...register("businessRegNo", {
                                })} 
                                InputProps={{ readOnly: isReadOnly }}
                                sx={{ m: 1, minWidth: '90%' }}
                            />
                        </TableCell>
                    </TableRow>
                    </TableBody>
                </Table>
                </TableContainer>
              </form>

              <div className='btn_right'>
                  <div>
                    <Button variant="contained" color="primary" onClick={handleSubmit(onSubmit)}>{t('message.common.btn.add')}</Button>
                  </div>
              </div>
            </CardContent>
  
          </MainCard>
        </Modal>

      </>
  )
}

export default CompanyWriteLayer;
  